"use strict";

var _regeneratorRuntime = require("/home/alfredo/Workspace/CarnesValidadas/Plataforma/v1/cv-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(parser);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parser;

function _parser() {
  var data = require("@babel/parser");

  _parser = function _parser() {
    return data;
  };

  return data;
}

function _codeFrame() {
  var data = require("@babel/code-frame");

  _codeFrame = function _codeFrame() {
    return data;
  };

  return data;
}

var _missingPluginHelper = require("./util/missing-plugin-helper");

function parser(pluginPasses, _ref, code) {
  var parserOpts, _ref$highlightCode, highlightCode, _ref$filename, filename, results, _iterator, _step, plugins, _iterator2, _step2, plugin, parserOverride, ast, loc, missingPlugin, codeFrame;

  return _regeneratorRuntime.wrap(function parser$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          parserOpts = _ref.parserOpts, _ref$highlightCode = _ref.highlightCode, highlightCode = _ref$highlightCode === void 0 ? true : _ref$highlightCode, _ref$filename = _ref.filename, filename = _ref$filename === void 0 ? "unknown" : _ref$filename;
          _context.prev = 1;
          results = [];
          _iterator = _createForOfIteratorHelper(pluginPasses);

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              plugins = _step.value;
              _iterator2 = _createForOfIteratorHelper(plugins);

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  plugin = _step2.value;
                  parserOverride = plugin.parserOverride;

                  if (parserOverride) {
                    ast = parserOverride(code, parserOpts, _parser().parse);
                    if (ast !== undefined) results.push(ast);
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          if (!(results.length === 0)) {
            _context.next = 9;
            break;
          }

          return _context.abrupt("return", (0, _parser().parse)(code, parserOpts));

        case 9:
          if (!(results.length === 1)) {
            _context.next = 14;
            break;
          }

          return _context.delegateYield([], "t0", 11);

        case 11:
          if (!(typeof results[0].then === "function")) {
            _context.next = 13;
            break;
          }

          throw new Error("You appear to be using an async parser plugin, " + "which your current version of Babel does not support. " + "If you're using a published plugin, you may need to upgrade " + "your @babel/core version.");

        case 13:
          return _context.abrupt("return", results[0]);

        case 14:
          throw new Error("More than one plugin attempted to override parsing.");

        case 17:
          _context.prev = 17;
          _context.t1 = _context["catch"](1);

          if (_context.t1.code === "BABEL_PARSER_SOURCETYPE_MODULE_REQUIRED") {
            _context.t1.message += "\nConsider renaming the file to '.mjs', or setting sourceType:module " + "or sourceType:unambiguous in your Babel config for this file.";
          }

          loc = _context.t1.loc, missingPlugin = _context.t1.missingPlugin;

          if (loc) {
            codeFrame = (0, _codeFrame().codeFrameColumns)(code, {
              start: {
                line: loc.line,
                column: loc.column + 1
              }
            }, {
              highlightCode: highlightCode
            });

            if (missingPlugin) {
              _context.t1.message = "".concat(filename, ": ") + (0, _missingPluginHelper.default)(missingPlugin[0], loc, codeFrame);
            } else {
              _context.t1.message = "".concat(filename, ": ").concat(_context.t1.message, "\n\n") + codeFrame;
            }

            _context.t1.code = "BABEL_PARSE_ERROR";
          }

          throw _context.t1;

        case 23:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 17]]);
}